import { render } from "./MyBooks.vue?vue&type=template&id=35399d56"
import script from "./MyBooks.vue?vue&type=script&lang=js"
export * from "./MyBooks.vue?vue&type=script&lang=js"

import "./MyBooks.vue?vue&type=style&index=0&id=35399d56&lang=scss"

import exportComponent from "/var/www/sites/qiyas.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__